const isEmpty = (obj: unknown): boolean => {
  if (typeof obj === 'object' && obj !== null)
    return Object.keys(obj).length === 0
  if (typeof obj === 'string') return obj.trim().length === 0

  return true
}

export default isEmpty
